<template>
    <v-layout justify-center>
        <v-dialog v-model="show" width="500px">
            <template v-slot:activator="{ on }">
                <v-btn class="caption" block color="primary" text dark v-on="on">Создать группу модулей</v-btn>
            </template>
            <v-card>
                <v-toolbar dark color="blue lighten-2">
                    <v-btn icon dark @click="show = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Группа модулей</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn dark text @click="copyModuleGroup" >
                            <v-icon>save</v-icon>
                            Копия
                        </v-btn>
                        <v-btn dark text @click="saveValue" >
                            <v-icon>save</v-icon>
                            {{moduleGroupModel.id === null ? ' Создать' : '\t\t Сохранить'}}
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-list subheader class="content">
                    <v-container fluid>
                        <v-layout>
                            <v-flex xs12>
                                <v-col cols="12" md12 class="my-0 py-0">
                                    <span>ID группы модулей: {{moduleGroupModel.id}}</span>
                                </v-col>
                                <v-col cols="12" md12 class="my-0 py-0">
                                    <v-text-field
                                            v-model="moduleGroupModel.title"
                                            :counter="28"
                                            label="Название группы модулей"
                                            required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" xs12 class="pt-1 my-0 py-0" >
                                    <v-select
                                            :items="types"
                                            label="Тип группы модулей"
                                            v-model="moduleGroupModel.type"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" xs12 class="pt-1 my-0 py-0" v-if="botTypeBits.length > 1">
                                    <v-select
                                            :items="botTypeBits"
                                            label="Отнести группу к подстройке бота"
                                            v-model="moduleGroupModel.bot_type_bit"
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" xs12 class="pt-1 my-0 py-0" >
                                    <v-switch
                                            class="ma-0 pa-0"
                                            v-model="moduleGroupModel.visible"
                                            inset
                                            label="Видимость в главной группе" color="primary"
                                            :false-value="0"
                                            :true-value="1"
                                    ></v-switch>
                                </v-col>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-list>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                color="success"
                right
        >
            Успешно сохранено!
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
    
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'MessageForm',
    components: {

    },
    data() {
        return {
            show: false,
            snackbar: false,
            moduleBlock: false,
            modules: [],
            moduleGroupModel: {
                id: null
            },
            botTypeBits: [0],
            types: [
                { value: 0, text: 'Общие модули' },
                { value: 1, text: 'Настройки бота' },
                { value: 2, text: 'Настройки реферальной системы' }
            ]
        }
    },
    props: ['editModuleGroupIndex', 'dialog'],
    methods: {
        saveValue() {
            this.$store.dispatch('moduleGroups/saveModuleGroup', this.moduleGroupModel).then(response => {
                this.moduleGroupModel.id = response.id
                this.moduleGroupModel.visible = response.visible
                this.snackbar = true
            })
        },
        copyModuleGroup() {
            this.moduleGroupModel.id = null
            this.$store.dispatch('moduleGroups/saveModuleGroup', this.moduleGroupModel).then(response => {
                this.moduleGroupModel = response
                this.snackbar = true
            })
            this.show = false
        },
        loadModel(index) {
            for (let i = 0; i <= 15; i++) { // 1 - fedresurs
                if ((this.bot.type & 1 << i) === Math.pow(2, i)) { this.botTypeBits.push(i + 1) }
            }
            if (index === null) {
                this.moduleGroupModel = JSON.parse(JSON.stringify(this.moduleGroupModelDef))
            } else {
                this.moduleGroupModel = JSON.parse(JSON.stringify(this.moduleGroups[index]))
            }
        }

    },
    filters: {
        truncate(text, length, suffix) {
            if (text.length > length) {
                return text.substring(0, length) + suffix
            } else { return text }
        }
    },
    computed: {
        ...mapGetters({
            moduleGroups: 'moduleGroups/moduleGroups',
            moduleGroupModelDef: 'moduleGroups/modelDefault',
            getBotById: 'bots/getBotById'
        }),
        bot() { return this.getBotById(this.$route.params['pathMatch']) }
    },
    watch: {
        dialog() {
            this.dialog === true ? this.show = true : this.show = false
        },
        show() {
            if (this.show === false) {
                this.moduleGroupModel = Object.assign({}, this.moduleGroupModelDef)
                this.$emit('close')
            } else {
                this.loadModel(this.editModuleGroupIndex)
            }
        }
    },
    created() { this.$store.dispatch('moduleGroups/changeBotIdModelDefault', this.$route.params['pathMatch']) }
}
</script>

<style scoped>
    #create .v-speed-dial {
        position: absolute;
    }

    #create .v-btn--floating {
        position: relative;
    }
    .v-text-field input {
        font-size: 0.2px;
    }
    .v-text-field__slot {
        font-size: 0.2px;
    }
    .container {
      width: 100vw;
      height: 70vh;
      display: flex;
      flex-direction: column;
    }
    .titlebar {
      flex-shrink: 0;
    }

    .content {
      flex-grow: 1;
      overflow-x: auto;
    }
</style>
